export const environment = {
  production: false,
  apiUrl: 'https://api.internal.baaskit.com',
  msalConfig: {
    auth: {
      clientId: '1db1de52-879e-46ea-91da-e45147388a1b',
      authority: 'https://login.microsoftonline.com/63c72e4f-31e4-49dc-a920-0d0530fa738b/v2.0',
      redirectUri: 'http://localhost:4200/auth',
      postLogoutRedirectUri: 'http://localhost:4200'
    }
  }
};